import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { Moderator } from './moderator.model'
@Injectable({
  providedIn: 'root'
})
export class ModeratorService {
  getCreatedate() {
    throw new Error('Method not implemented.');
  }

  noAuthHeader = { headers: new HttpHeaders({ 'NoAuth': 'True' }) };
  constructor(private http: HttpClient) { }

  postModerator(moderator: Moderator) {
    console.log('Inside post moderator', moderator);
    return this.http.post(environment.apiBaseUrl + '/auth/signup', moderator, this.noAuthHeader);
  }

  getAllTickets() {
    return this.http.get(environment.apiBaseUrl + '/moderator/get-all-tickets')
  }

  getAllTransactions() {
    return this.http.get(environment.apiBaseUrl + '/moderator/get-all-transactions')
  }

  getAllExperts() {
    return this.http.get(environment.apiBaseUrl + '/moderator/get-all-expert')
  }

  getAllDates() {
    return this.http.get(environment.apiBaseUrl + '/moderator/get-all-expert')
  }

  assignExpert(assignment) {
    return this.http.post<any>(environment.apiBaseUrl + '/moderator/assign-expert', assignment)
  }

  closeTicket(ticketID) {
    return this.http.post<any>(environment.apiBaseUrl + '/moderator/close-ticket', ticketID)
  }

  getClosedTickets() {
    return this.http.get(environment.apiBaseUrl + '/moderator/get-all-closed-tickets')
  }

  getAllCustomer() {
    return this.http.post(environment.apiBaseUrl + '/moderator/get-all-customers', {})
  }

  addCreditToCustomer(creditData) {
    return this.http.post(environment.apiBaseUrl + '/moderator/add-credit-customer', creditData)
  }

  addPaymentInfo(paymentInfo) {
    return this.http.post(environment.apiBaseUrl + '/moderator/add-payment-info', paymentInfo)
  }

  getPaymentInfo(creditDetails) {
    return this.http.post(environment.apiBaseUrl + '/moderator/get-payment-info', creditDetails)
  }

  addPerTransactionCredit(transactionData) {
    return this.http.post(environment.apiBaseUrl + '/moderator/add-per-transaction-credit', transactionData)
  }

  addStandardAlloy(standardAlloy) {
    return this.http.post(environment.apiBaseUrl + '/moderator/add-standard-alloy', standardAlloy)
  }

  deleteStandardAlloy(standardAlloyId) {
    return this.http.post(environment.apiBaseUrl + '/moderator/delete-standard-alloy', standardAlloyId)
  }

  getAllUnverifiedMessages() {
    return this.http.get(environment.apiBaseUrl + '/moderator/get-all-unverified-messages')
  }

  getTicketDetails(ticketId) {
    return this.http.post(environment.apiBaseUrl + '/moderator/get-ticket-data', ticketId)
  }

  verifyMessage(messageDetails) {
    return this.http.post(environment.apiBaseUrl + '/moderator/verify-message', messageDetails)
  }

  editMessage(messageDetails) {
    return this.http.post(environment.apiBaseUrl + '/moderator/edit-message', messageDetails)
  }

  deleteMessage(messageDetails) {
    return this.http.post(environment.apiBaseUrl + '/moderator/delete-message', messageDetails)
  }

  deleteProfile(userId) {
    return this.http.post(environment.apiBaseUrl + '/moderator/delete-profile', userId)
  }

  editProfile(user) {
    return this.http.post(environment.apiBaseUrl + '/moderator/edit-profile', user)
  }

  addPerTransactionCreditExpert(creditDetails) {
    return this.http.post(environment.apiBaseUrl + '/moderator/add-per-transaction-credit-expert', creditDetails)
  }

  getPerTransactionCreditExpert(creditDetails) {
    return this.http.post(environment.apiBaseUrl + '/moderator/get-transaction-credit-expert', creditDetails)
  }

  async sendInvoice(customerID) {
    let x = {
      customerId: customerID
    }
    return await fetch(environment.apiBaseUrl + '/moderator/send-invoice', {
      method: 'POST',
      body: JSON.stringify(x),
      headers: {
        'Content-type': 'application/json; charset=UTF-8'
      }
    })
  }

  // async sendInvoiceDateFilter(customerID, startDate, endDate){
  //   let x = {
  //     customerId: customerID,
  //     startDate: startDate,
  //     endDate: endDate
  //   }
  //   return await fetch(environment.apiBaseUrl + '/moderator/send-invoice-date-filter', {
  //     method: 'POST',
  //     body: JSON.stringify(x),
  //     headers: {
  //       'Content-type': 'application/json; charset=UTF-8'
  //     }
  //   })
  // }

  async sendInvoiceDateFilter(customerID, startDate, endDate) {
    try {
      let x = {
        customerId: customerID,
        startDate: startDate,
        endDate: endDate
      }
      let returnedBody = await fetch(environment.apiBaseUrl + '/moderator/send-invoice-date-filter', {
        method: 'POST',
        body: JSON.stringify(x),
        headers: {
          'Content-type': 'application/json; charset=UTF-8'
        }
      });
      console.log(returnedBody);

      return returnedBody;
    } catch (err) {
     //console.log('error', err)
    }
  }

  async sendTransactionDateRange(customerID, startDate, endDate) {
    try {
      let x = {
        customerId: customerID,
        startDate: startDate,
        endDate: endDate
      }
      let returnedBody = await fetch(environment.apiBaseUrl + '/moderator/get-transactions-date-range', {
        method: 'POST',
        body: JSON.stringify(x),
        headers: {
          'Content-type': 'application/json; charset=UTF-8'
        }
      });
      console.log(returnedBody);

      return returnedBody;
    } catch (err) {
      console.log('error', err)
    }
  }

  async sendCurvesDateRange(customerID, startDate, endDate) {
    try {
      let x = {
        customerId: customerID,
        startDate: startDate,
        endDate: endDate
      }
      let returnedBody = await fetch(environment.apiBaseUrl + '/moderator/get-curves-date-range', {
        method: 'POST',
        body: JSON.stringify(x),
        headers: {
          'Content-type': 'application/json; charset=UTF-8'
        }
      });
      console.log(returnedBody);

      return returnedBody;
    } catch (err) {
      console.log('error', err)
    }
  }

  async sendTicketsRaisedDateRange(customerID, startDate, endDate) {
    try {
      let x = {
        customerId: customerID,
        startDate: startDate,
        endDate: endDate
      }
      let returnedBody = await fetch(environment.apiBaseUrl + '/moderator/get-tickets-raised-date-range', {
        method: 'POST',
        body: JSON.stringify(x),
        headers: {
          'Content-type': 'application/json; charset=UTF-8'
        }
      });
      console.log(returnedBody);

      return returnedBody;
    } catch (err) {
      console.log('error', err)
    }
  }

  async sendTicketsClosedDateRange(customerID, startDate, endDate) {
    try {
      let x = {
        customerId: customerID,
        startDate: startDate,
        endDate: endDate
      }
      let returnedBody = await fetch(environment.apiBaseUrl + '/moderator/get-tickets-closed-date-range', {
        method: 'POST',
        body: JSON.stringify(x),
        headers: {
          'Content-type': 'application/json; charset=UTF-8'
        }
      });
      console.log(returnedBody);

      return returnedBody;
    } catch (err) {
      console.log('error', err)
    }
  }

  async sendTicketsAnsweredDaysDateRange(customerID, startDate, endDate) {
    try {
      let x = {
        customerId: customerID,
        startDate: startDate,
        endDate: endDate
      }
      let returnedBody = await fetch(environment.apiBaseUrl + '/moderator/get-tickets-answered-days-date-range', {
        method: 'POST',
        body: JSON.stringify(x),
        headers: {
          'Content-type': 'application/json; charset=UTF-8'
        }
      });
      console.log(returnedBody);

      return returnedBody;
    } catch (err) {
      console.log('error', err)
    }
  }

  getUnverifiedMessageCounts() {
    return this.http.get(environment.apiBaseUrl + '/moderator/get-unverified-message-count')
  }
}
